import type { LoadEvent, ServerLoadEvent } from '@sveltejs/kit';

export const ROUTE_ROUTES = '/routes';
export const ROUTE_MAP = '/map';
export const ROUTE_MAP_POI_TEMPLATE = '/map/:category/poi/:urlIdentifier';
export const ROUTE_MAP_FILTERS = '/map/filters';
export const ROUTE_MAP_TRAFFIC = '/map/traffic';
export const ROUTE_SEARCH_CAR = '/routes/search-car';
export const ROUTE_ZOI = '/routes/zoi';
export const ROUTE_ZOI_POI = '/routes/zoi/poi';
export const ROUTE_ZOI_FILTERS = '/routes/zoi/filters';
export const ROUTE_ZOI_SETTINGS = '/routes/zoi/settings';
export const ROUTE_COSTS = '/routes/costs';
export const ROUTE_COSTS_EDIT = '/routes/costs/edit';
export const ROUTE_INSTRUCTIONS = '/routes/instructions';
export const ROUTE_ON_THE_WAY = '/routes/on-the-way';
export const ROUTE_ON_THE_WAY_POI = '/routes/on-the-way/poi';
export const ROUTE_ON_THE_WAY_FILTERS = '/routes/on-the-way/filters';
export const ROUTE_SEARCH = '/routes/search';
export const ROUTE_SEARCH_POI = '/routes/search/poi';
export const ROUTE_SEARCH_FILTERS = '/routes/search/filters';
export const ROUTE_RESULTS = '/routes/results';
export const ROUTE_GROUP_ZOI_SETTINGS = '/(map)/routes/zoi/settings';
export const ROUTE_GROUP_SEARCH_CAR = '/(map)/routes/search-car';
export const ROUTE_GROUP_DETAILS = '/(map)/routes/(details)';
export const ROUTE_GROUP_COSTS = `${ROUTE_GROUP_DETAILS}/costs`;
export const ROUTE_GROUP_ZOI = `${ROUTE_GROUP_DETAILS}/zoi`;
export const ROUTE_GROUP_ZOI_POI = `${ROUTE_GROUP_DETAILS}/zoi/poi`;
export const ROUTE_GROUP_RESULTS_ADDRESSES = '/(map)/routes/results/[...addresses]';
export const ROUTE_GROUP_SEARCH = `${ROUTE_GROUP_DETAILS}/search`;
export const ROUTE_GROUP_SEARCH_POI = `${ROUTE_GROUP_DETAILS}/search/poi`;
export const ROUTE_GROUP_SEARCH_FILTERS = `${ROUTE_GROUP_DETAILS}/search/filters`;
export const ROUTE_GROUP_ON_THE_WAY = `${ROUTE_GROUP_DETAILS}/on-the-way`;
export const ROUTE_GROUP_ON_THE_WAY_POI = `${ROUTE_GROUP_DETAILS}/on-the-way/poi`;
export const ROUTE_GROUP_ON_THE_WAY_FILTERS = `${ROUTE_GROUP_DETAILS}/on-the-way/filters`;
export const ROUTE_GROUP_EXPENSE_NOTE = `${ROUTE_GROUP_DETAILS}/expense-note`;
export const ROUTE_GROUP_EXPENSE_NOTE_EDIT = `${ROUTE_GROUP_DETAILS}/expense-note/edit`;
export const ROUTE_GROUP_INSTRUCTIONS = `${ROUTE_GROUP_DETAILS}/instructions`;
export const PROFILE = '/profile';
export const PROFILE_FAVORITES = '/profile/favorites';
export const PROFILE_INFORMATION = '/profile/information';

export type RoutesIds =
        typeof ROUTE_ROUTES |
        typeof ROUTE_MAP |
        typeof ROUTE_MAP_POI_TEMPLATE |
        typeof ROUTE_MAP_FILTERS |
        typeof ROUTE_MAP_TRAFFIC |
        typeof ROUTE_SEARCH_CAR |
        typeof ROUTE_ZOI |
        typeof ROUTE_ZOI_POI |
        typeof ROUTE_ZOI_FILTERS |
        typeof ROUTE_ZOI_SETTINGS |
        typeof ROUTE_COSTS |
        typeof ROUTE_COSTS_EDIT |
        typeof ROUTE_INSTRUCTIONS |
        typeof ROUTE_ON_THE_WAY |
        typeof ROUTE_ON_THE_WAY_POI |
        typeof ROUTE_ON_THE_WAY_FILTERS |
        typeof ROUTE_SEARCH |
        typeof ROUTE_SEARCH_POI |
        typeof ROUTE_SEARCH_FILTERS |
        typeof ROUTE_RESULTS |
	typeof PROFILE_FAVORITES;

type LoadAnyEvent = LoadEvent | ServerLoadEvent;

export function isRouteItineraryResult(event: LoadAnyEvent) {
	return event.route.id === ROUTE_GROUP_RESULTS_ADDRESSES;
}

export function isRouteInsideItineraryDetailsContext(event: LoadAnyEvent) {
	return event.route.id?.startsWith(ROUTE_GROUP_DETAILS) ?? false;
}

export function isRouteItineraryResultCanonical(event: LoadAnyEvent) {
	return event.route.id === ROUTE_GROUP_RESULTS_ADDRESSES && Boolean(event.params.addresses);
}
